import { Tabs } from 'antd';
import Layout from 'components/Layout';
import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router';
import { useParams } from 'react-router-dom';
import AddressesTab from './AddressesTab';
import CreditHistory from './CreditCardHistory';
import GiftCardHistory from './GiftCardHistory';
import OrdersTab from './OrdersTab';
import Overview from './Overview';
import PromotionsTab from './PromotionsTab';
import { StyledWrapper } from './styles';

const TAB_ITEMS = [
  { label: 'Overview', path: '', key: '1' },
  { label: 'Activity', path: '/activity', key: '7' },
  { label: 'Orders', path: '/orders', key: '2' },
  { label: 'Addresses', path: '/addresses', key: '5' },
  { label: 'Promotions', path: '/promotions', key: '6' },
  { label: 'Financials', path: '/credit-history', key: '3' },
  { label: 'Gift cards', path: '/gift-card', key: '4' },
];

function Container() {
  const navigate = useNavigate();
  const location = useLocation();
  const { id: customerId } = useParams();

  const activeKey = React.useMemo(() => {
    const path = location.pathname;
    if (path.includes('/activity')) return '7';
    if (path.includes('/orders')) return '2';
    if (path.includes('/addresses')) return '5';
    if (path.includes('/promotions')) return '6';
    if (path.includes('credit-history')) return '3';
    if (path.includes('gift-card')) return '4';
    return '1';
  }, [location.pathname]);

  return (
    <Layout header={(
      <Layout.Header
        backTitle="Customers"
        backPath="/console/customers"
      />
    )}
    >
      <StyledWrapper>
        <Tabs
          items={TAB_ITEMS}
          activeKey={activeKey}
          onChange={(key) => {
          const tab = TAB_ITEMS.find((t) => t.key === key);
          if (tab) navigate(`/console/customers/${customerId}${tab.path}`);
        }}
        />
        <Outlet />
      </StyledWrapper>
    </Layout>
  );
}

export default Container;
